// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"540":"a97a1b87c2502f35c027","556":"b711e4c10a73c3b9e435","952":"c46243d6cb3110ae2077"}[chunkId] + ".css";
};